export { default, PriceInfoV2 } from './PriceInfo';
